import React from "react";
import { withRouter } from "react-router-dom";
import AppContext from "../../AppContext";
import { Button } from "reactstrap";
import axios from "axios";

import { withTranslation } from "react-i18next";

import styles from "../../styles/products.module.css";

class Imprint extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      overlayToggle: false,
      imprint: [],
    };
  }

  static contextType = AppContext;

  componentDidMount() {
    const { i18n } = this.props;
    const langString = i18n.language;
    const adaptedLangString =
      langString.slice(0, 2) + "-" + langString.slice(2);
    console.log("Adapted lang: ", adaptedLangString);

    axios
      .get(
        `https://policies.ttprivacy.com/api/v1/imprints/legalentity/TTDE/language/${adaptedLangString}`
      )
      .then((res) => {
        const imprint = res.data;
        this.setState({ imprint });
      });
  }

  async toggleModal() {
    if (this.state.overlayToggle) {
      this.setState({ overlayToggle: false });
    } else {
      this.setState({ overlayToggle: true });
    }
  }

  render() {
    const { t } = this.props;
    const { overlayToggle } = this.state;

    return (
      <>
        <div
          className={`${overlayToggle ? styles.show : styles.hide} ${
            styles.disclaimerContainer
          } ${styles.scaleDisclaimerContainer}`}
          style={{ zIndex: "999999999" }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "left",
              height: "100%",
              overflow: "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                fontSize: "15px",
                fontFamily: "Bosch-Regular",
              }}
            >
              <div
                dangerouslySetInnerHTML={{ __html: this.state.imprint.text }}
              />
            </div>
            <div>
              <Button
                onClick={() => {
                  this.toggleModal();
                }}
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  borderRadius: "40px",
                  width: "40px",
                  height: "40px",
                  background: "#038ecf",
                  border: "none",
                  fontFamily: "Bosch-Bold",
                }}
              >
                x
              </Button>
            </div>
          </div>
        </div>

        <Button
          onClick={(e) => {
            this.toggleModal();
          }}
          className={`${styles.imprintBtn} ${styles.scaleDisclaimer}`}
        >
          {t("imprint.button")}
        </Button>
      </>
    );
  }
}

export default withRouter(withTranslation()(Imprint));

